import red from '@material-ui/core/colors/red'
import { createTheme } from '@material-ui/core/styles'

export const theme = createTheme({
  palette: {
    primary: {
      main: '#2E86BD'
    },

    secondary: {
      main: '#E64147'
    },

    error: {
      main: red.A400
    },

    background: {
      default: '#fff'
    }
  },

  typography: {
    h3: {
      fontSize: '1.5rem',
      fontWeight: 500,

      '@media (min-width:600px)': {
        fontSize: '2rem'
      },

      '@media (min-width: 959.95px)': {
        fontSize: '3rem'
      }
    },

    h4: {
      fontSize: '1.3rem',

      '@media (min-width:600px)': {
        fontSize: '1.9rem'
      },

      '@media (min-width: 959.95px)': {
        fontSize: '2.125rem'
      }
    },

    body1: {
      fontSize: '0.875rem',

      '@media (min-width:600px)': {
        fontSize: '1rem'
      },

      '@media (min-width: 959.95px)': {
        fontSize: '1.125rem'
      }
    }
  },

  overrides: {
    MuiFormLabel: {
      root: {
        '&$focused': {
          color: 'rgba(0, 0, 0, 0.87)'
        }
      }
    },

    MuiAccordion: {
      root: {
        boxShadow: 'none',

        '&$expanded': {
          boxShadow: `0px 2px 1px -1px rgba(0,0,0,0.2),
            0px 1px 1px 0px rgba(0,0,0,0.14),
            0px 1px 3px 0px rgba(0,0,0,0.12)`
        }
      }
    },

    MuiOutlinedInput: {
      root: {
        '&$focused': {
          '& $notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 0.87)'
          }
        }
      }
    }
  }
})
